import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import React, { ChangeEvent, FormEvent } from 'react';
import { useSelector } from 'react-redux';
import './style.scss';

interface PropsValue {
    value: string;
    setValue: Function;
    placeholder?: string;
    onSubmit?: Function;
}

const InputSearch = ({ value, setValue, placeholder, onSubmit }: PropsValue) => {
    const { data: strings } = useSelector((state: ApplicationState) => state.locale);

    if (!placeholder) {
        placeholder = strings.SEARCH;
    }

    const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value);
    };

    const handleSubmit = (e: FormEvent) => {
        e.preventDefault();
        onSubmit && onSubmit();
    };

    return (
        <>
            <div className="input-search inner-addon left-addon">
                <form onSubmit={handleSubmit}>
                    <i className="material-icons-outlined align-middle input-icon" onClick={handleSubmit}>
                        {Constants.icons.SEARCH}
                    </i>
                    <input className="form-control" onChange={handleSearch} placeholder={placeholder} type="search" value={value} />
                </form>
            </div>
        </>
    );
};

export default InputSearch;
